import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import {
  useDeleteUser,
  useGetUerList,
  useImpersonateUser,
} from '../../hooks/react-query/useAdmin';
import { Mapper } from '../../utils/user/mapper';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/Table';
import {
  DownFilled,
  EyeIcon,
  LeftArrow,
  PencilIcon,
  TrashIcon,
} from '../../icons';
import { Rounded } from '../../components/elements/rounded';
import { CustomModal, PageTitle } from '../../components/ui';
import { UserForm } from '../../components/user/userForm';
import { HeaderToolBar } from '../../components/elements/headerToolBar';
import Pagination from '../../components/elements/pagination/pagination';

import {
  exportToFile,
  generatePdfDocument,
} from '../../utils/importDriver/funtions';
import { queryClient } from '../../utils/queryClient';
import { QUERY_KEYS } from '../../config/constants';
import UploadMultipleUser from '../../components/user/uploadMultipleUser';
import Container from '../../components/elements/container';
import { TableSkeletion } from '../../components/elements/skeletions';
import Loader from '../../components/elements/loader';
import { NoDataFound } from '../../components/elements/noDataFound';
const { USER_LIST, EDIT_USER_FORM_FIELDS } = QUERY_KEYS;

const User = () => {
  const navigate = useNavigate();

  const [userListData, setUserListData] = useState();
  const [openEditModal, setEditModal] = useState(false);
  const [selectedUser, setUserData] = useState({});
  const [impersonateUser, setImpersonateUser] = useState({});
  const [multipleUserView, setMultipleUsersView] = useState(false);
  const [openColumnListModal, setCoumnListModal] = useState(false);
  const [selectedColumns, setSavedColumns] = useState([]);
  const [filterState, setFilterState] = useState({
    length: 25,
    orderType: 'asc',
    orderBy: 'id',
    search: '',
    page: 1,
  });

  const { data: userData, isLoading } = useGetUerList(filterState);

  useImpersonateUser(impersonateUser);

  const { mutate: deleteUser, isLoading: isDeleteUserLoading } =
    useDeleteUser();

  useEffect(() => {
    if (userData && userData.pages && userData.pages[0].data) {
      setUserListData(Mapper(userData.pages[0], 'users'));
    }
  }, [userData]);

  if (multipleUserView) {
    return (
      <UploadMultipleUser handleBackClick={() => setMultipleUsersView(false)} />
    );
  }

  const handleLoginAsUser = (data) => {
    setImpersonateUser({ id: data.id, afm: data.afm, username: data.username });
  };

  const handleDeleteUser = (data) => {
    deleteUser(data.id, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [USER_LIST, filterState],
        });
      },
    });
  };

  const handleExport = (type) => {
    if (type === 'pdf') {
      generatePdfDocument(userListData, 'Χρήστες');
    } else {
      exportToFile(userListData, type, 'users');
    }
  };

  const handleSortOrder = (item) => {
    let orderBy = item.name;
    let orderType = 'asc';
    if (item.name !== filterState?.orderBy) {
      orderBy = item.name;
    } else {
      orderType = filterState.orderType === 'asc' ? 'desc' : orderType;
    }

    setFilterState((prev) => ({ ...prev, orderType, orderBy, page: 1 }));
  };

  const handleSearch = (searchKey) => {
    setFilterState((prev) => ({ ...prev, search: searchKey, page: 1 }));
  };

  const handlePagination = (pageNum) => {
    setFilterState((prev) => ({ ...prev, page: pageNum }));
  };

  if (isLoading && !userListData) {
    return (
      <Container>
        <TableSkeletion />
      </Container>
    );
  }

  if (!userListData || !userListData.data) {
    return (
      <Container>
        <NoDataFound />
      </Container>
    );
  }

  const createHeaders = () => {
    const { columns } = userListData;
    let headers = [];

    if (columns && columns.length) {
      columns.forEach((itm) => {
        if (!selectedColumns.includes(itm.name)) {
          let headerTemplate = itm.label;
          if (itm.ordering) {
            headerTemplate = (
              <button
                className="cursor-pointer flex"
                onClick={() => handleSortOrder(itm)}
              >
                <h5 className="whitespace-nowrap text-body-large">
                  {headerTemplate}
                </h5>
                <span className="sort">
                  <DownFilled className={clsx('fill-[#595454] h-6 w-6')} />
                </span>
              </button>
            );
          }

          headers.push(
            <TableHead key={itm.label} scope="col">
              <h5 className="whitespace-nowrap text-body-large">
                {headerTemplate}
              </h5>
            </TableHead>
          );
        }
      });

      return (
        <TableHeader>
          <TableRow>{headers}</TableRow>
        </TableHeader>
      );
    }
  };

  const createBody = () => {
    let rows = [];
    const { columns, data } = userListData;

    const dataArray = [...data];

    if (dataArray.length) {
      dataArray.forEach((item) => {
        const itm = { ...item };
        let cells = [];
        let itmComponent;

        columns.forEach((column) => {
          if (!selectedColumns.includes(column.name)) {
            itmComponent = itm[column.name] || '';
            if (column.type === 'email') {
              itmComponent = (
                <a className="text-primary" href={`mailto:${itmComponent}`}>
                  {itmComponent}
                </a>
              );
            } else if (column.type === 'link') {
              itmComponent = (
                <div className="flex items-center gap-x-6">
                  <Rounded className="border border-fadedgrey p-3 flex items-center justify-center">
                    <button
                      type="button"
                      onClick={() => handleLoginAsUser(itm)}
                    >
                      <EyeIcon width={20} height={20} />
                    </button>
                  </Rounded>
                  <Rounded className="border border-fadedgrey p-3 flex items-center justify-center">
                    <button type="button" onClick={() => handleDeleteUser(itm)}>
                      <TrashIcon width={20} height={20} />
                    </button>
                  </Rounded>
                  <Rounded className="border border-fadedgrey p-3 flex items-center justify-center">
                    <button type="button" onClick={() => handleEditClick(itm)}>
                      <PencilIcon
                        width={20}
                        height={20}
                        className="stroke-black"
                      />
                    </button>
                  </Rounded>
                </div>
              );
            }

            cells.push(
              <TableCell
                key={column.name}
                className={'text-body whitespace-nowrap'}
              >
                {itmComponent}
              </TableCell>
            );
          }
        });

        rows.push(<TableRow key={itm.id}>{cells}</TableRow>);
      });
      return <TableBody>{rows}</TableBody>;
    }

    return (
      <TableBody>
        <TableRow>
          <TableCell
            className="text-body whitespace-nowrap text-center"
            colSpan="10"
          >
            Κανένα Αποτέλεσμα
          </TableCell>
        </TableRow>
      </TableBody>
    );
  };

  const handleEditClick = (data) => {
    setUserData(data);
    setEditModal(true);
  };

  const handleColumnSave = (columns) => {
    setSavedColumns(columns);
    setCoumnListModal(false);
  };

  const handleEditModalState = () => {
    queryClient.invalidateQueries({
      queryKey: [USER_LIST, filterState],
    });
    queryClient.invalidateQueries({
      queryKey: [EDIT_USER_FORM_FIELDS, selectedUser.id],
    });
    setEditModal(false);
    setUserData({});
  };

  return (
    <>
      {isLoading && userListData && <Loader />}
      <Container className="flex flex-col gap-6 max-h-[88vh] max-lg:px-0">
        {isDeleteUserLoading && <Loader className="fill-primary" />}
        <PageTitle
          displaySearch={false}
          wrapperClassName="flex-col max-lg:px-5"
          title={
            <div className="flex max-lg:gap-x-8 items-center">
              <button className='lg:p-2' onClick={() => navigate('/dashboard')}>
                <LeftArrow width={32} height={32} />
              </button>
              <h2>Users</h2>
            </div>
          }
          endComponent={
            <HeaderToolBar
              showAddUser={true}
              onUserAdded={() => {
                queryClient.invalidateQueries({
                queryKey: [USER_LIST, filterState],
                });
              }}
              openColumnListModal={openColumnListModal}
              handleSearch={handleSearch}
              searchTerm={filterState.search}
              configurations={userListData}
              columnList={userListData?.columns}
              handleExport={handleExport}
              selectedColumns={selectedColumns}
              handleColumnSave={handleColumnSave}
              handleAddMultipleUsers={() => setMultipleUsersView(true)}
              handleColumnListClick={(value) => setCoumnListModal(value)}
            />
          }
        />
        <Table wrapperClassName="lg:p-4 p-2 scrollbar overflow-auto max-lg:rounded-none max-lg:min-h-[250px]">
          {createHeaders()}
          {createBody()}
        </Table>
        {selectedUser && selectedUser.id && (
          <CustomModal
            triggerComponent={<></>}
            handleClick={(value) => {
              setEditModal(value);
            }}
            wrapperClass="grid"
            openModal={openEditModal}
          >
            <div className="container-sm lg:mx-auto flex flex-col items-center gap-y-3 lg:gap-y-5 max-lg:px-5">
              <div className="flex gap-3 items-center flex-col w-full py-5 lg:py-6 lg:px-6">
                <h3 className="max-lg:place-self-start">Τροποποίηση Χρήστη</h3>
              </div>
              <UserForm
                mode="edit"
                userId={selectedUser?.id}
                handleClose={handleEditModalState}
              />
            </div>
          </CustomModal>
        )}

        <Pagination
          currentPage={userListData?.pagination?.current_page}
          totalCount={userListData?.records?.total}
          from={userListData?.records.from}
          to={userListData?.records.to}
          pageSize={filterState.length}
          onPageChange={handlePagination}
        />
      </Container>
    </>
  );
};

export default User;
